/**
 * Zod validation schemas for World entities
 *
 * Validates world creation requests and world data.
 */

import { z } from 'zod';

/**
 * World validation
 */
export const WorldSchema = z.object({
  id: z.string().min(1),
  householdId: z.string().nullable(),
  type: z.enum(['custom', 'readymade']),
  name: z.string().min(1).max(100),
  description: z.string().min(1).max(1000),
  imageUrl: z.string().url().nullable(),
  createdAt: z.date(),
  isActive: z.boolean(),
});

/**
 * CreateWorldRequest validation
 * Used for POST /createWorld endpoint
 */
export const CreateWorldRequestSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().min(1).max(1000),
  imageBase64: z.string().optional(), // Optional base64 encoded image
});
